import { z } from "zod";

// ─── PayConcepts ─────────────────────────────────────────────────────────────
export const payConceptIdSchema = z.string().uuid("ID de concepto de pago inválido");

export const createPayConceptSchema = z.object({
  code: z.string().min(1, "El código es requerido").max(20).toUpperCase(),
  name: z.string().min(1, "El nombre es requerido").max(250),
  currencyId: z.string().uuid("Moneda requerida"),
  unitRate: z.union([z.string(), z.number()]).transform(v => String(v)),
});

export const updatePayConceptSchema = createPayConceptSchema.partial();

export const payConceptQuerySchema = z.object({
  deleted: z.enum(["true", "false"]).optional(),
});

// ─── Exports ─────────────────────────────────────────────────────────────────
export type PayConceptId = z.infer<typeof payConceptIdSchema>;
export type CreatePayConcept = z.infer<typeof createPayConceptSchema>;
export type UpdatePayConcept = z.infer<typeof updatePayConceptSchema>;
export type PayConceptQuery = z.infer<typeof payConceptQuerySchema>;
